/*global chrome*/
import React from "react";
import { Link } from "react-router-dom";
import API from "../../api.js";
import Slider from "react-slick";

class VideoTuts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homePage: false,
      list: [],
      sliderStyles: { marginLeft: "0px", marginRight: "0px", width: "100%" },
    };
  }
  componentDidMount() {
    API({
        method: 'GET',
        url: "display/video",
        data: 'json',
    }).then(data => {
        this.setState({ list: data.data.response.data });
    }).catch(() => {
        this.setState({ lockSubmit: false });
    }); 

}

  render() {
    const Turorialvideos = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      // slidesToShow: 5,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: true,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: true,
          },
        },
      ],
    };

    return (
      <div className="four-videos-sec video-section left-arrow-slider slider-dot-arrow">
        <h2 h2 className="primary-heading text-center">
        <span className="wpl-badge pte-naati-badge text-white">PTE</span> <br className="d-block" /> Tutorial Videos
        </h2>
        <Slider {...Turorialvideos}>
          {this.state.list.map((item, key) => (
            <div key={key}>
                <div className="iframe-video-wrapper">
                <iframe
                className="iframe-video"
                    src={item.video}
                    title={`PTE Video ${key}`}
                    allowFullScreen
                />
                </div>
            </div>
          ))}
        </Slider>
        <div className="d-flex justify-content-center">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/@LanguageAcademyPTE"
            className="primary-btn"
          >
            VIEW ALL VIDEOS{" "}
            <img
              src="/images/web-new-images/right-arrow.svg"
              alt="Register Now"
            />
          </a>
        </div>
      </div>
    );
  }
}

export default VideoTuts;
